import { DataFlag } from '@naturalcycles/shared'

export const B1_TEMP_EXTRACTION_DATAFLAGS = new Set([
  DataFlag.TEMP_EXTRACTION_DISCARDED_DUE_TO_FLAT_SPECTRUM,
  DataFlag.TEMP_EXTRACTION_DISCARDED_DUE_TO_HOLES,
  DataFlag.TEMP_EXTRACTION_DISCARDED_DUE_TO_NO_STABLE_POINTS,
  DataFlag.TEMP_EXTRACTION_INSUFFICIENT_SLEEP,
  DataFlag.TEMP_EXTRACTION_TEMP_CORRECTED,
])

export const B1_ERROR = {
  WRONG_DEVICE_CONNECTED: 'B1_WRONG_DEVICE_CONNECTED',
  NOT_CONNECTED: 'B1_NOT_CONNECTED',
  CONNECTED_WHEN_UNEXPECTED: 'B1_CONNECTED_WHEN_UNEXPECTED',
}
